import React, { useRef, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import '../App.css'; // Loads in the CSS styling file
import PageHeader from "../components/PageHeader.js";
import ChatInput from "../components/ChatInput.js";
import ChatButtons from "../components/ChatButtons.js";
import { sendAuthorMessage } from "../components/sendAuthorMessage";
import InfoPanel from "../components/InfoPanel.js"
import CollapseIcon from "../components/data/CollapseIcon.png";

// Import profile pictures 
import speakerProfilePicture from "../components/data/profilePicture.png";
import botProfilePicture from "../components/data/botProfilePicture.png";


function createNewConversation(userID, storyID) {
    return new Promise((resolve, reject) => {
        // Make the POST request
        fetch('https://versify-back-b066d2bc73d1.herokuapp.com/create-conversation', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ userID, storyID })
        })
            .then(response => response.json()) // Parse the response as JSON
            .then(data => {
                if (data.error) {
                    console.error('Error:', data.error);
                    reject(new Error(data.error));
                } else if (data.success) {
                    resolve(data.conversationID);
                }
            })
            .catch(error => {
                // console.error('There was an error:', error);
                reject(error);
            });
    });
}

const ChatPage = () => {
    const [panelView, setPanelView] = useState("author"); // Tracks which view we should display on LHS panel 
    const [botResponse, setBotResponse] = useState('');


    // Access the 'id' parameter from the URL using useParams hook
    const { id: storyID } = useParams();

    const [lastNode, setLastNode] = useState(false);
    const [showInfoPanel, setShowInfoPanel] = useState(true); // Determines if we should hide the

    // All of these values are hardcoded for now. This is the ONLY place they are hardcoded.
    const userID = '6530481bc7e8e961aa0cba7b';
    const conversationIDLocal = useRef(null); // This is dynamically updated 

    const [allNodeData, setAllNodeData] = useState(null); // Upon first render, pull all data about pre-set nodes and store it here.
    const [isAllNodeDataLoaded, setIsAllNodeDataLoaded] = useState(false);

    const [allQuestionsData, setAllQuestionsData] = useState(null); // Upon first render, pull all user questions and store it here

    const [currentChatHistoryData, updateChatHistoryData] = useState(null); // Local copy of all chatHistory data
    const [retrievedData, setRetrievedData] = useState(null);
    const [globalData, setGlobalData] = useState({
        currentNodeID: "",
        nextNodeID: ""
    });

    const firstRender = useRef(true);
    const chatContainerRef = useRef(null);

    // Get data for all the current reader questions and store them in allQuestionsData
    useEffect(() => {
        const getQuestions = async () => {
            try {
                // Using fetch
                const response = await fetch(`https://versify-back-b066d2bc73d1.herokuapp.com/votes/story/${storyID}`);
                const data = await response.json();
                setAllQuestionsData(data);
            } catch (error) {
                console.error('Error fetching votes:', error);
                // Handle the error state appropriately
            }
        }
        getQuestions();
    }, []);


    // Get data for all nodes and store them in allNodeData
    useEffect(() => {
        const fetchAllNodes = async () => {
            const allNodesEndpoint = `https://versify-back-b066d2bc73d1.herokuapp.com/allNodes/${storyID}`;
            try {
                const response = await fetch(allNodesEndpoint);
                if (response.ok) {
                    const data = await response.json();
                    setAllNodeData(data);
                    setIsAllNodeDataLoaded(true); // <-- set to true here
                } else {
                    // console.error('Failed to fetch chat history.');
                    return null;
                }
            } catch (error) {
                // console.error('Error fetching chat history:', error);
                return null;
            }
        };
        fetchAllNodes();
        // }
    }, []);

    async function getStoryData(currentNodeID) {
        const fetchStoryData = async () => {
            const storyEndpoint = `https://versify-back-b066d2bc73d1.herokuapp.com/story/${storyID}`;
            try {
                const response = await fetch(storyEndpoint);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return await response.json();
            } catch (error) {
                console.error('Error fetching story data:', error);
                throw error;
            }
        };
        return await fetchStoryData();  // Make sure to return the result here.
    }

    // Get title, first main point, first premise 
    useEffect(() => {
        async function fetchAndSetData() {
            try {
                const storyData = await getStoryData(globalData.currentNodeID);
                setRetrievedData(storyData);
            } catch (error) {
                console.error('Error in fetchAndSetData:', error);
            }
        }
        fetchAndSetData();
    }, [globalData]);


    useEffect(() => {

        // Store this data in the chat history
        if (firstRender.current && isAllNodeDataLoaded && retrievedData) {

            setGlobalData(prevData => ({
                ...prevData,
                currentNodeID: retrievedData.firstNode
            }));

            // Find the first node
            let targetContent = null;
            let targetImage = null; 
            for (let i = 0; i < allNodeData.length; i++) {
                if (allNodeData[i]._id === retrievedData.firstNode) {
                    targetContent = allNodeData[i].content;
                    if (allNodeData[i].pictureAbove) {
                        targetImage = allNodeData[i].pictureAbove; 
                    }

                    const nextNodeID = allNodeData[i].next[0];

                    // Update the globalData with the new nextNodeID
                    setGlobalData(prevData => ({
                        ...prevData,
                        nextNodeID: nextNodeID
                    }));
                    break;
                }
            }

            createNewConversation(userID, storyID)
                .then(async (conversationID) => {
                    conversationIDLocal.current = conversationID;

                    // // Here, you are calling getChatHistory but not using its return value.
                    // // Make sure to handle the returned data appropriately.
                    let chatHistoryData = []; 
                    if (targetImage) {
                        chatHistoryData = [
                            { role: 'assistant', content: retrievedData.title },
                            { role: 'assistant', content: targetContent, image : targetImage }
                        ];
                    } else {
                    chatHistoryData = [
                        { role: 'assistant', content: retrievedData.title },
                        { role: 'assistant', content: targetContent }
                    ];
                    }
                    updateChatHistoryData(chatHistoryData);
                    await sendAuthorMessage(storyID, `${conversationID}`, userID, retrievedData.title); // Send Title
                    await sendAuthorMessage(storyID, `${conversationID}`, userID, targetContent); // Send the first paragraph
                })
                .catch(error => {
                    console.error('Failed to create new conversation:', error);
                });
            firstRender.current = false;
        }
    }, [isAllNodeDataLoaded, retrievedData]);


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // This useEffect scrolls to the bottom of the chat container when currentChatHistoryData changes
    // It makes sure that we do not scroll to the bottom of the container if the reader is seeing the first node 
    // for the first time 
    useEffect(() => {
        if (currentChatHistoryData) {
            if (currentChatHistoryData.length > 2) {
                const container = chatContainerRef.current;
                if (container) {
                    container.scrollTop = container.scrollHeight;
                }
            }
        }
    }, [currentChatHistoryData]);

    // Handles what happens if user clicks to minimize/expand the infoPanel
    const collapseExpand = () => {
        setShowInfoPanel(prevShowInfoPanel => !prevShowInfoPanel); // Flips the value
    }

    // Handles what happens when the reader asks the author a question 
    const askAuthorQuestion = () => {
        // Cause a re-render
        const newChatHistory = [
            ...currentChatHistoryData,
            { role: 'bot-leaderboard-response', content: "Your question has been added to the leaderboard. Please toggle to the leaderboard view and vote on questions you and other readers have submitted. Authors typically respond to top questions each week!" },
        ];
        updateChatHistoryData(newChatHistory);

    };


    // Shows a blank chat screen if data is not finished loading
    if (!currentChatHistoryData) {
        return (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", height: "100%" }}>
                <PageHeader />
                {/* <img
                style={{
                    height: '100%',
                }}
                id="logoPhoto"
                src={logo}
                alt="Blog Logo"
            /> */}
            </div>
        )
    }

    // Renders the full chat screen with LHS panel 
    return (
        <div>
            <PageHeader />
            <div className="articleContainer" style={{ position: 'relative', width: '100%' }}>
                {
                    showInfoPanel ? (
                        <div className="infoPanelContainer">
                            <InfoPanel
                                showInfoPanel={showInfoPanel}
                                setShowInfoPanel={setShowInfoPanel}
                                allQuestionsData={allQuestionsData}
                                setAllQuestionsData={setAllQuestionsData}
                                userID={userID}
                                panelImageURL={retrievedData.panelImage}
                                storyID={storyID}
                                panelView={panelView}
                                setPanelView={setPanelView}
                            />
                        </div>
                    ) : (
                        <img
                            src={CollapseIcon}
                            style={{
                                position: 'absolute',
                                paddingTop: '25px',
                                left: '25px',
                                height: '25px',
                                zIndex: 1000,
                                cursor: 'pointer'
                            }}
                            alt="Collapse Button"
                            onClick={collapseExpand}
                        />
                    )
                }
                <div className="chatContainer" >
                    <div className="chat-messages" ref={chatContainerRef} >
                        <div className='messageContainer' id='messageContainer'>
                            <div className='mainChat'></div>

                            {/*Render messages based on chatHistory*/}
                            {currentChatHistoryData && currentChatHistoryData.map((message, index) => (

                                <div key={index} className="chatMessage">

                                    {index === 0 ? (
                                        // Render the title and subtitle
                                        <div>
                                            <div className="title">{message.content}</div>
                                            <div className="readerResponse"
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    fontSize: "16px",
                                                    paddingTop: "5px",
                                                    paddingBottom: "5px"
                                                }}
                                            >
                                                {/** Inserts the author's first name only */}
                                                Have a conversation with {retrievedData.author.split(' ')[0]}'s latest article.
                                            </div>
                                        </div>
                                    ) : (message.role === 'assistant') ? (
                                        // Render for the all author responses including their FAQs
                                        <div>
                                            {
                                                message.image ? (
                                                    <div style={{
                                                        display: 'flex',
                                                        justifyContent: 'center', // Center horizontally
                                                        alignItems: 'center', // Center vertically
                                                        height: '100%', // Set to the height of the parent container if needed
                                                        paddingTop: '30px'
                                                    }}>
                                                        <img style={{ maxHeight: '500px' }} src={message.image} alt="description" />
                                                    </div>
                                                ) : null

                                            }
                                            <div className='authorResponse'>
                                                <div className='speaker-picture-box'>
                                                    <img className="speaker-picture" src={retrievedData.headshot} alt="Profile Picture" />
                                                </div>
                                                <div className="paragraph" style={{ whiteSpace: 'pre-line', paddingTop: '20px' }}
                                                    dangerouslySetInnerHTML={{ __html: message.content }}>
                                                    {/* {message.content} */}

                                                </div>
                                            </div>
                                        </div>
                                    ) : (message.role === 'user') ? (
                                        // Render for all reader elements
                                        <div className='readerResponse'>
                                            <div className='speaker-picture-box'>
                                                <img className="speaker-picture" src={speakerProfilePicture} alt="Profile Picture" />
                                            </div>
                                            <div>
                                            <div className="paragraph" style={{ whiteSpace: 'pre-line', paddingTop: '20px' }}>
                                                    {message.content}
                                                    </div> 
                                            </div>
                                        </div>
                                    ) : (message.role === 'user-question') ? (
                                        // Render for all reader chat elements
                                        <div className='readerResponse'>
                                            <div className='speaker-picture-box'>
                                                <img className="speaker-picture" src={speakerProfilePicture} alt="Profile Picture" />
                                            </div>
                                            <div>
                                            <div className="paragraph" style={{ whiteSpace: 'pre-line', paddingTop: '20px' }}>

                                                {message.content}
                                                </div> 
                                            </div>
                                            {/* <Tooltip title="Click here to submit this question to the author" placement="top" sx={{ tooltip: { fontSize: '1.5em' } }}>
                                                    <img style={{
                                                        height: '20px',
                                                        cursor: 'pointer'
                                                    }}
                                                        onClick={askAuthorQuestion}
                                                        src={askAuthor} alt="Ask Author" />
                                                </Tooltip> */}
                                        </div>
                                    ) : (message.role === 'loading') ? (
                                        // Uses same style as author response
                                        <div className='authorResponse'>
                                            <div className='speaker-picture-box'>
                                                <img className="speaker-picture" src={botProfilePicture} alt="Profile Picture" />
                                            </div>
                                            <div>
                                                <div className="loading-animation" style={{ whiteSpace: 'pre-line', paddingTop: '20px' }}></div>
                                                            </div>
                                                        </div>
                                                    ) : (message.role === 'bot-leaderboard-response') ? (
                                                        // Render bot response that tells you you've added to the leaderboard
                                                        <div className='authorResponse'>
                                                            <div className='speaker-picture-box'>
                                                                <img className="speaker-picture" src={botProfilePicture} alt="Profile Picture" />
                                                            </div>
                                                            <div>
                                                                <div className="paragraph" style={{ whiteSpace: 'pre-line', paddingTop: '20px' }}>
                                                                    {message.content}
                                                                </div>
                                                            </div>
                                                        </div>

                                                    ) : (
                                                        // Render for all other bot elements
                                                        <div className='authorResponse'>
                                                            <div className='speaker-picture-box'>
                                                <img className="speaker-picture" src={botProfilePicture} alt="Profile Picture" />
                                            </div>
                                            <div>
                                            <div className="paragraph" style={{ whiteSpace: 'pre-line', paddingTop: '20px' }}>
                                                                    {message.content}
                                                                </div>
                                            </div>
                                        </div>
                                    )
                                    }
                                </div>
                            ))}
                            <ChatButtons
                                globalData={globalData}
                                setGlobalData={setGlobalData}
                                currentChatHistoryData={currentChatHistoryData}
                                updateChatHistoryData={updateChatHistoryData}
                                allNodeData={allNodeData}
                                setLastNode={setLastNode}
                                panelView={panelView}
                                setPanelView={setPanelView}
                                showInfoPanel={showInfoPanel}
                                setShowInfoPanel={setShowInfoPanel}
                                sendAuthorMessage={sendAuthorMessage}
                                conversationID={conversationIDLocal}
                                setBotResponse={setBotResponse}
                                storyID={storyID}
                                userID={userID}
                                chatContainerRef={chatContainerRef}

                            />
                        </div>
                        <div style={{ marginLeft: 'auto', minHeight: '25px', maxHeight: '25px' }}> {/* Add minHeight here */}
                            {lastNode === true ? (
                                <div>

                                    {/* PLACEHOLDER FOR ENDING SCREEN */}

                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="chat-input">
                        <ChatInput
                            globalData={globalData}
                            setGlobalData={setGlobalData}
                            conversationID={conversationIDLocal}
                            currentChatHistoryData={currentChatHistoryData}
                            updateChatHistoryData={updateChatHistoryData}
                            storyID={storyID}
                            userID={userID}
                            retrievedData={retrievedData}
                            botResponse={botResponse}
                            setBotResponse={setBotResponse}
         />
                    </div>
                </div>
            </div>
        </div >
    );
};

export default ChatPage;
